import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Col, Row } from 'reactstrap';
import FeeOption from './fees/FeeOption';
import { FormInputField, FormSelectField } from '../../../common/components/formFields';

const FEE_VALIDATION_ERRORS_OBJECT_KEY_PREFIX = 'organizationForm.organizationFees';

export const paymentMethods = [
  { label: 'Credit Card', value: 'CREDIT_CARD' },
  { label: 'Credit Facility', value: 'CREDIT_FACILITY' },
];

function DealerPaymentForm({ disabled, values }) {
  const validationErrors = useSelector((state) => state.dealers.get('validationErrors'));

  return (
    <>
      <h4 className="my-3 fw-bold">Fees</h4>
      <Row>
        <Col md={4}>
          <FormSelectField
            name="paymentMethod"
            label="Payment Method"
            options={paymentMethods}
            values={values}
            disabled={disabled}
            required
          />
        </Col>
        <Col md={4}>
          <FormInputField name="promoCode" label="Promo Code" disabled={true} />
        </Col>
      </Row>
      <FeeOption
        name="monthlySubscription"
        label="Monthly Subscription"
        disabled={disabled}
        values={values}
        validationMessage={
          validationErrors?.[
            `${FEE_VALIDATION_ERRORS_OBJECT_KEY_PREFIX}.monthlySubscriptionInPence`
          ]
        }
        required
      />
      <FeeOption
        name="launch"
        label="Launch Fee"
        disabled={disabled}
        values={values}
        validationMessage={
          validationErrors?.[`${FEE_VALIDATION_ERRORS_OBJECT_KEY_PREFIX}.launchInPence`]
        }
        required
      />
      <FeeOption
        name="saleForLessThan1000"
        label="Sale £0 - £1,000"
        disabled={disabled}
        values={values}
        validationMessage={
          validationErrors?.[
            `${FEE_VALIDATION_ERRORS_OBJECT_KEY_PREFIX}.saleForLessThan1000InPence`
          ]
        }
        required
      />
      <FeeOption
        name="saleBetween1001And5000"
        label="Sale £1,001 - £5,000"
        disabled={disabled}
        values={values}
        validationMessage={
          validationErrors?.[
            `${FEE_VALIDATION_ERRORS_OBJECT_KEY_PREFIX}.saleBetween1001And5000InPence`
          ]
        }
        required
      />
      <FeeOption
        name="saleBetween5001And10000"
        label="Sale £5,001 - £10,000"
        disabled={disabled}
        values={values}
        validationMessage={
          validationErrors?.[
            `${FEE_VALIDATION_ERRORS_OBJECT_KEY_PREFIX}.saleBetween5001And10000InPence`
          ]
        }
        required
      />
      <FeeOption
        name="saleBetween10001And15000"
        label="Sale £10,001 - £15,000"
        disabled={disabled}
        values={values}
        validationMessage={
          validationErrors?.[
            `${FEE_VALIDATION_ERRORS_OBJECT_KEY_PREFIX}.saleBetween10001And15000InPence`
          ]
        }
        required
      />
      <FeeOption
        name="saleForMoreThan15000"
        label="Sale Over £15,000"
        disabled={disabled}
        values={values}
        validationMessage={
          validationErrors?.[
            `${FEE_VALIDATION_ERRORS_OBJECT_KEY_PREFIX}.saleForMoreThan15000InPence`
          ]
        }
        required
      />
      <FeeOption
        name="purchaseForLessThan1000"
        label="Purchase £0 - £1,000"
        disabled={disabled}
        values={values}
        validationMessage={
          validationErrors?.[
            `${FEE_VALIDATION_ERRORS_OBJECT_KEY_PREFIX}.purchaseForLessThan1000InPence`
          ]
        }
        required
      />
      <FeeOption
        name="purchaseBetween1001And5000"
        label="Purchase £1,001 - £5,000"
        disabled={disabled}
        values={values}
        validationMessage={
          validationErrors?.[
            `${FEE_VALIDATION_ERRORS_OBJECT_KEY_PREFIX}.purchaseBetween1001And5000InPence`
          ]
        }
        required
      />
      <FeeOption
        name="purchaseBetween5001And10000"
        label="Purchase £5,001 - £10,000"
        disabled={disabled}
        values={values}
        validationMessage={
          validationErrors?.[
            `${FEE_VALIDATION_ERRORS_OBJECT_KEY_PREFIX}.purchaseBetween5001And10000InPence`
          ]
        }
        required
      />
      <FeeOption
        name="purchaseBetween10001And15000"
        label="Purchase £10,001 - £15,000"
        disabled={disabled}
        values={values}
        validationMessage={
          validationErrors?.[
            `${FEE_VALIDATION_ERRORS_OBJECT_KEY_PREFIX}.purchaseBetween10001And15000InPence`
          ]
        }
        required
      />
      <FeeOption
        name="purchaseForMoreThan15000"
        label="Purchase Over £15,000"
        disabled={disabled}
        values={values}
        validationMessage={
          validationErrors?.[
            `${FEE_VALIDATION_ERRORS_OBJECT_KEY_PREFIX}.purchaseForMoreThan15000InPence`
          ]
        }
        required
      />
    </>
  );
}

DealerPaymentForm.defaultProps = {
  disabled: false,
};

DealerPaymentForm.propTypes = {
  disabled: PropTypes.bool,
  values: PropTypes.object.isRequired,
};

export default DealerPaymentForm;
